export default "__VITE_ASSET__Mb$rBktM__"